import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { Button } from './Button';
import './Navbar.css';

function Navbar() {

  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const { logout, currentUser } = UserAuth();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  
  const handleLogout = async () => {
    try {
      await logout();
      console.log("Logging out");
    } catch (e) {
      console.log(e.message);
    }
  }

  return (
    <div>
      <nav className='navbar'>
        <div className='navbar-container container'>
          <Link  to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img src='./images/logo1.png' alt='Woof logo'></img>
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
              <li className='nav-item'>
                <Link to='/account' className='nav-links' onClick={closeMobileMenu}>
                  Account
                </Link>
              </li>
              <li className='nav-btn'>
                {button ? (
                  <Link to='/' className='btn-link' onClick={handleLogout}>
                    <Button buttonStyle='btn--other'>SIGN OUT</Button>
                  </Link>
                ) : (
                  <Link to='/' className='btn-link'>
                    <Button
                      buttonStyle='btn--other'
                      buttonSize='btn--mobile'
                      onClick={handleLogout}>
                      SIGN OUT
                    </Button>
                  </Link>
                )}
              </li>
            </ul>
        </div>
      </nav>
    </div>
  )
}

export default Navbar